import { UserRoles } from "../constants/enums";
import { roleBasedRoutes } from "./roleBasedRoutes";

/**
 * Builds a map of path → Set<role> from roleBasedRoutes.
 * Used by PrivateRoute to validate that the current user's role
 * is actually authorized to access a given path.
 */
const buildRoutePermissions = () => {
  const pathToRoles = {};

  for (const [role, routes] of Object.entries(roleBasedRoutes)) {
    if (role === UserRoles.DEFAULT) continue;

    for (const { path } of routes) {
      if (!pathToRoles[path]) {
        pathToRoles[path] = new Set();
      }
      pathToRoles[path].add(role);
    }
  }

  return pathToRoles;
};

const pathToRoles = buildRoutePermissions();

/**
 * Returns the set of roles allowed to access a given path.
 */
export const getAllowedRoles = (path) => pathToRoles[path] || new Set();

/**
 * Checks if a specific role is allowed to access a path.
 */
export const isRoleAllowedForPath = (role, path) => {
  const allowed = pathToRoles[path];
  return allowed ? allowed.has(role) : false;
};
